module.exports = __webpack_public_path__ + "static/media/button-question.00789dd7.png";